export const contestConstants = {
    CONTEST_LIST_REQUEST: 'CONTEST_LIST_REQUEST',
    CONTEST_LIST_SUCCESS: 'CONTEST_LIST_SUCCESS',
    CONTEST_LIST_ERROR: 'CONTEST_LIST_ERROR',
    CONTEST_SEARCH_REQUEST : 'CONTEST_SEARCH_REQUEST',

    CONTEST_ADDED_REQUEST:'CONTEST_ADDED_REQUEST',
    CONTEST_ADDED_SUCCESS:'CONTEST_ADDED_SUCCESS',
    CONTEST_ADDED_FAILURE:'CONTEST_ADDED_FAILURE',  
        

    CONTEST_GET_REQUEST:'CONTEST_GET_REQUEST',
    CONTEST_GET_SUCCESS:'CONTEST_GET_SUCCESS',
    CONTEST_GET_FAILURE:'CONTEST_GET_FAILURE',
    
    CONTEST_BY_ID_REQUEST : 'CONTEST_BY_ID_REQUEST',
    CONTEST_BY_ID_SUCCESS : 'CONTEST_BY_ID_SUCCESS',
    CONTEST_BY_ID_FAILURE : 'CONTEST_BY_ID_FAILURE',

    CONTEST_GET_ACTIVE_REQUEST:'CONTEST_GET_ACTIVE_REQUEST',
    CONTEST_GET_ACTIVE_SUCCESS:'CONTEST_GET_ACTIVE_SUCCESS',
    CONTEST_GET_ACTIVE_FAILURE:'CONTEST_GET_ACTIVE_FAILURE',

    CONTEST_DELETE_REQUEST:'CONTEST_DELETE_REQUEST',
    CONTEST_DELETE_SUCCESS:'CONTEST_DELETE_SUCCESS',
    CONTEST_DELETE_FAILURE:'CONTEST_DELETE_FAILURE',
};
